import { render, staticRenderFns } from "./PaymentLinks.vue?vue&type=template&id=85b10e20&"
import script from "./PaymentLinks.vue?vue&type=script&lang=js&"
export * from "./PaymentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports